module.exports = __webpack_public_path__ + "img/44_30.168225f6.png";